import { t } from '@moovly/i18n';
import { Button, useModal } from '@moovly/ui';
import * as React from 'react';
import CreateOrganizationGroupModal from '../modals/CreateOrganizationGroupModal';

interface CreateGroupButtonContainerProps {
  label?: string;
}

const CreateGroupButtonContainer: React.FC<CreateGroupButtonContainerProps> = ({
  label = t('groups.create.button'),
}) => {
  const { isOpen, openModal, ...otherModalProps } = useModal();
  return (
    <>
      <Button onClick={openModal} className="btn btn-primary" label={label} />
      {isOpen && <CreateOrganizationGroupModal {...otherModalProps} />}
    </>
  );
};

export default CreateGroupButtonContainer;
